import { IProduct } from '../../../../content-management/models/Product';
import { ElementType, IElement } from '../../../models/Element';
import { ElementHeaderType } from '../../utils';

export type FeaturedProducts = IElement & {
  heading: string;
  heading_type: ElementHeaderType;
  description: string;
  featured_products: Array<IProduct>;
};

export const defaultFeaturedProducts: FeaturedProducts = {
  id: 0,
  name: ElementType.FEATURED_PRODUCTS,
  heading: 'Relevante Modules',
  heading_type: ElementHeaderType.H2,
  description:
    '<p>Voor makelaars is het van groot belang dat objecten (woningen en BOG) goed vindbaar zijn voor potentiële kopers. Dit kan tegenwoordig via Funda, Jaap en andere woningsites, maar ook de eigen website van de makelaar is hierin van essentieel belang.</p>',
  featured_products: [],
};
